import {config} from "./config";
import {request} from "./request";

function createOrUpdateUserLevelInfo(data, cb, fail_cb) {
    request.post.call(this, config.apiList.userLevelInfos, data, null, cb, fail_cb)
}

function getUserLevelInfos(data, cb, fail_cb) {
    request.get.call(this, config.apiList.userLevelInfos, data, cb, fail_cb)
}

function getUsersForSetting(data, cb, fail_cb) {
    request.get.call(this, config.apiList.getUsersForSetting, data, cb, fail_cb)
}

function deleteUserLevelInfo(data, cb, fail_cb) {
    request.deleteRequest.call(this, config.apiList.userLevelInfos + '/' + data.id, data, cb, fail_cb)
}


var userLeveInfoApi = {
    createOrUpdateUserLevelInfo: createOrUpdateUserLevelInfo,
    getUserLevelInfos: getUserLevelInfos,
    deleteUserLevelInfo: deleteUserLevelInfo,
    getUsersForSetting: getUsersForSetting,
}

export {userLeveInfoApi}